// src/pages/ContactUsPage.js
import React from 'react';
import contactBg_1x from '../assets/reading-towers/gallery/x04-living-kitchen-1536.jpg';
import contactBg_2x from '../assets/reading-towers/gallery/x04-living-kitchen-1536.jpg';

const ContactUsPage = () => {
  const formSubmitActionUrl = "https://formsubmit.co/Leasing@Readingtower.com";

  const primaryColor = "text-teal-700";
  const primaryBorderColor = "border-teal-700/50";
  const focusRingColor = "focus:ring-teal-500";
  const focusBorderColor = "focus:border-teal-500";
  const buttonBgColor = "bg-teal-600";
  const buttonHoverBgColor = "hover:bg-teal-700";

  return (
    <div className="bg-white">
      {/* Background Image Section */}
      <div
        className="relative bg-cover bg-center py-20 md:py-32 lg:py-40"
        style={{
          backgroundImage: `image-set(${`url(${contactBg_1x})`} 1x, ${`url(${contactBg_2x})`} 2x)`,
        }}
      >
        <div className="relative container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 lg:gap-16 items-start">
            {/* Left Box: Leasing Office */}
            <div
              className={`bg-white bg-opacity-90 p-8 md:p-10 rounded-md shadow-xl border ${primaryBorderColor} text-center space-y-6`}
            >
              <h2
                className={`text-2xl font-semibold uppercase tracking-wider ${primaryColor}`}
              >
                Leasing Office
              </h2>
              <div className="text-gray-700 space-y-1">
                <p className="font-medium pt-1">(877) 601-7366</p>
                <p className="font-medium pt-1">
                  <a href="mailto:Leasing@Readingtower.com" className="hover:underline">
                    Leasing@Readingtower.com
                  </a>
                </p>
                <p>601 Penn Street</p>
                <p>Reading, PA 19601</p>
              </div>
              <hr className="border-t border-gray-300 w-1/2 mx-auto" />
              <div>
                <h3
                  className={`text-xl font-semibold uppercase tracking-wider ${primaryColor} mb-2`}
                >
                  Schedule Your Visit
                </h3>
                <p className="text-gray-600">
                  Contact us to learn more about current availability and tour
                  options.
                </p>
              </div>
            </div>

            {/* Right Box: Contact Us Form */}
            <div
              className={`bg-white bg-opacity-90 p-8 md:p-10 rounded-md shadow-xl border ${primaryBorderColor}`}
            >
              <h2
                className={`text-2xl font-semibold uppercase tracking-wider ${primaryColor} text-center mb-8`}
              >
                Contact Us
              </h2>
              <form
                action={formSubmitActionUrl}
                method="POST"
                className="space-y-6"
              >
                {/* Hidden fields for FormSubmit customization */}
                <input
                  type="hidden"
                  name="_subject"
                  value="New Contact Form Submission - Reading Tower Apartments"
                />

                <input type="hidden" name="_replyto" />
                <input type="text" name="_honey" style={{ display: "none" }} />

                <div>
                  <label
                    htmlFor="firstName"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    First name *
                  </label>
                  <input
                    type="text"
                    name="firstName"
                    id="firstName"
                    required
                    className={`mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none ${focusRingColor} ${focusBorderColor} sm:text-sm`}
                  />
                </div>
                <div>
                  <label
                    htmlFor="lastName"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Last name *
                  </label>
                  <input
                    type="text"
                    name="lastName"
                    id="lastName"
                    required
                    className={`mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none ${focusRingColor} ${focusBorderColor} sm:text-sm`}
                  />
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                  <div>
                    <label
                      htmlFor="email"
                      className="block text-sm font-medium text-gray-700 mb-1"
                    >
                      Email *
                    </label>
                    <input
                      type="email"
                      name="email"
                      id="email"
                      required
                      className={`mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none ${focusRingColor} ${focusBorderColor} sm:text-sm`}
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="phone"
                      className="block text-sm font-medium text-gray-700 mb-1"
                    >
                      Phone *
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      id="phone"
                      required
                      className={`mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none ${focusRingColor} ${focusBorderColor} sm:text-sm`}
                    />
                  </div>
                </div>
                <div>
                  <label
                    htmlFor="form_subject"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Subject
                  </label>
                  <input
                    type="text"
                    name="form_subject"
                    id="form_subject"
                    className={`mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none ${focusRingColor} ${focusBorderColor} sm:text-sm`}
                  />
                </div>
                <div>
                  <label
                    htmlFor="message"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Message
                  </label>
                  <textarea
                    name="message"
                    id="message"
                    rows="4"
                    className={`mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none ${focusRingColor} ${focusBorderColor} sm:text-sm`}
                  ></textarea>
                </div>
                <div className="text-center pt-2">
                  <button
                    type="submit"
                    className={`inline-flex justify-center py-2.5 px-8 border border-transparent shadow-sm text-sm font-medium rounded-md text-white ${buttonBgColor} ${buttonHoverBgColor} focus:outline-none focus:ring-2 focus:ring-offset-2 ${focusRingColor} transition-colors`}
                  >
                    Send Message
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUsPage;
